import { render, staticRenderFns } from "./resultat-patient-modal.html?vue&type=template&id=dddb2cd2&scoped=true&external"
import script from "./resultat-patient-modal.js?vue&type=script&lang=js&external"
export * from "./resultat-patient-modal.js?vue&type=script&lang=js&external"
import style0 from "./resultat-patient-modal.scss?vue&type=style&index=0&id=dddb2cd2&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dddb2cd2",
  null
  
)

export default component.exports